export default function Servicios() {
  return (
    <div id="wsite-content" className="wsite-elements wsite-not-footer">
      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-background-14" style={{ height: 'auto' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <h2 className="wsite-content-title">Servicios</h2>
                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  <font size="3">
                    Ofrecemos servicios que aportan a la sustentabilidad medioambiental, con foco en gestión de residuos, trazabilidad y cumplimiento normativo.
                  </font>
                </div>

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '50%', padding: '0 15px' }}>
                            <h2 className="wsite-content-title" style={{ fontSize: '1.4em' }}>Gestión de residuos RAAE</h2>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              <font size="3">
                                Se constituye como el principal servicio de reciclaje de E-WASTE a través de la valorización de residuos.
                              </font>
                            </div>
                            <div className="paragraph">
                              <ul>
                                <li>Reciclaje de metales no ferrosos</li>
                                <li>Transporte autorizado</li>
                                <li>Destrucción de activos estratégicos y borrado seguro de datos</li>
                                <li>Entrega de certificado de reciclaje</li>
                                <li>Informe de trazabilidad</li>
                              </ul>
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '50%', padding: '0 15px' }}>
                            <h2 className="wsite-content-title" style={{ fontSize: '1.4em' }}>Habilitaciones</h2>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              <font size="3">
                                Habilitados por ventanilla única para sistemas sectoriales SINADER, SIDREP y REP.
                              </font>
                            </div>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              <font size="3">
                                Contamos con transportes autorizados para el traslado de residuos sólidos industriales peligrosos y no peligrosos.
                              </font>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
